export default {
   "title": "",
   "description": "",
   "votetype": "S",
   "noofvotes": 1,
   "orderseq": 1,
}